export default __webpack_public_path__ + "static/media/completed-ico.4394e7ad.svg";